const ErrorPage = () => {
    return(
        <div className="error-container">
            <h2><center>Ooops... Something went wrong</center></h2>
            <h4><center>Please try again later</center></h4>
        </div>
    )
}

export default ErrorPage